const adminExhibitorRouter = [
  {
    path: '/admin/exhibitor',
    name: 'AdminExhibitorIndex',
    component: () => import('@/views/admin/exhibitor/index')
  },
  {
    path: '/admin/exhibitor/create',
    name: 'AdminExhibitorCreate',
    component: () => import('@/views/admin/exhibitor/create')
  },
  {
    path: '/admin/exhibitor/edit',
    name: 'AdminExhibitorEdit',
    component: () => import('@/views/admin/exhibitor/edit')
  },
  {
    path: '/admin/exhibitor/detail',
    name: 'AdminExhibitorDetail',
    component: () => import('@/views/admin/exhibitor/detail')
  },
  {
    path: '/admin/exhibitor/track',
    name: 'AdminExhibitorTrack',
    component: () => import('@/views/admin/exhibitor/track')
  }
]

export default adminExhibitorRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/exhibitor.js